module.exports = __webpack_public_path__ + "img/transfer.cb574ecd.svg";